<template>
	<div class="userList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                	<el-input size clearable v-model="searchForm.nickname" placeholder="请输入代理商昵称"></el-input>
                </el-form-item>
				<el-form-item>
					<el-input size clearable v-model="searchForm.agent_no" placeholder="请输入代理商编号"></el-input>
				</el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="searchForm.p1_nickname" placeholder="请输入所属代理商昵称"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-input size clearable v-model="searchForm.p1_agent_no" placeholder="请输入所属代理商编号"></el-input>
                </el-form-item>
                <el-form-item>
                	<el-date-picker v-model="rangeDate" type="daterange" range-separator="至" start-placeholder="创建开始日期"
                		end-placeholder="创建结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
                		@change="pickerChange"></el-date-picker>
                </el-form-item>
				
                
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="handleSearch(searchForm)">查询</el-button>

					<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
						@click="addWhiter()">添加白名单</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">
			<el-table :data="userTable" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" fixed type="index" label="ID" min-width="80">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="agent_no" label="代理商编号" min-width="120">
				</el-table-column>
				<el-table-column header-align="center" align="center" prop="nickname" label="代理商昵称" min-width="120">
				</el-table-column>
				
                <el-table-column header-align="center" align="center" prop="level" label="代理层级"min-width="150"></el-table-column>
                <el-table-column header-align="center" align="center" prop="p1_agent_no" label="所属机构编号" min-width="120">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="p1_nickname" label="所属机构名称" min-width="120">
                </el-table-column>
				<el-table-column header-align="center" align="center" prop="create_time" label="创建时间" min-width="150">
				</el-table-column>
				<!-- 操作 -->
				<el-table-column header-align="center" align="center" fixed="right" label="操作" min-width="100">
					<template slot-scope="scope">
						<el-button @click="removeWhiter(scope.row)" type="text" size="small">移除白名单</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页部分 -->
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:page-sizes="[10,20,50,100]" :current-page="currentPage" :page-size="pageSize" :total="total"
				layout="total, sizes, prev, pager, next, jumper" style="text-align: center"></el-pagination>
		</el-card>

		<el-dialog title="添加白名单" :visible.sync="addDialogVisible" width="60%" :before-close="handleClose">
			<el-form :model="whiterForm" size="small" label-width="120px"   :rules="agentRules" ref="whiterForm">
				<el-row>
					<el-col :span="10">
						<el-form-item label="代理商编号" prop="agent_no" >
							<el-input size clearable v-model="whiterForm.agent_no" placeholder="请输入代理商编号" @change="agentInput"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="10">
						<el-form-item label="代理商昵称">
							<el-input size clearable v-model="whiterForm.agent_name"  :disabled="true" placeholder="请输入代理商名称"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
                <el-row>
                	<el-col :span="10">
                		<el-form-item label="所属代理商昵称">
                			<el-input size clearable v-model="whiterForm.organization_agent_no"  :disabled="true" ></el-input>
                		</el-form-item>
                	</el-col>
                	<el-col :span="10">
                		<el-form-item label="所属代理商昵称">
                			<el-input size clearable v-model="whiterForm.organization_agent_name"  :disabled="true" ></el-input>
                		</el-form-item>
                	</el-col>
                </el-row>
                <el-row>
                	<el-col :span="10">
                		<el-form-item label="代理商层级">
                			<el-input size clearable v-model="whiterForm.level"  :disabled="true" ></el-input>
                		</el-form-item>
                	</el-col>
                </el-row>
				
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="whiterSubmit('whiterForm')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "creditCardaDjustment",
		data() {
			return {
				searchForm: {
					page: 1,
					limit: 10,
                    agent_no:'',
                    nickname:'',
                    p1_agent_no:'',
                    p1_nickname:'',
                    start_time:'',
                    end_time:'',
                    type:1
				},
				userTable: [],
				currentPage: 1, //当前页码
				pageSize: 10, //条数
				total: 0, //总数
				loading: false,
				//添加白名单
				addDialogVisible: false,
				whiterForm: {
                    agent_no:'',
                    type:'1'
				},
				agentRules:{
					agent_no: [{
						required: true,
						message: '请输入代理商编号',
						trigger: 'blur'
					}, ]
				},
                rangeDate: [], //绑定日期
			}
		},
        created() {
        	this.pickerOptions.disabledDate = (time) => { //禁用日期
        		if (this.currentDate !== '') {
        			let tempTime = 3600 * 1000 * 24 * 30;
        			let timer = new Date(this.currentDate).getTime();
        			let minTime = timer - tempTime;
        			let maxTime = timer + tempTime;
        			return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
        		}
        		return time.getTime() > Date.now();
        	}
        	this.pickerOptions.onPick = ({
        		minDate,
        		maxDate
        	}) => { //当前选中的日期
        		this.currentDate = minDate.getTime();
        		if (maxDate) {
        			this.currentDate = '';
        		}
        	}
        },
		mounted() {
			this.getData({
				page: 1,
				limit: 10,
                type:'1'
			});
		},

		methods: {
            pickerChange(DateArr) { //时间选择器
            	this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            	this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
            },
			//根据代理查询 政策
			agentInput(e){
				if(e){
                    this.$api.post('gray_list/getUserInfo',{agent_no:e}, res => {
                    	if (res.code == 0) {
                    		this.whiterForm = res.data;
                    		
                    	} else {
                    		this.$message.error(res.msg);
                    	}
                    })
				}
			},
			//保存代理商
			whiterSubmit(formName){
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('gray_list/addWhiteUser', {user_id:this.whiterForm.user_id,type:1}, res => {
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: res.msg,
									duration: 2000,
								})
								let params = this.searchForm;
								this.getData(params);
								this.frozenLoading = false;
								this.addDialogVisible = false;
								this.whiterForm = {
                                    agent_no:''
								};
								
							} else {
								this.$message.error(res.msg);
								this.frozenLoading = false;
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
            handleClose() {
            	this.addDialogVisible = false;
            	this.whiterForm = {
            	    agent_no:''
            	};
            },
			//添加白名单
			addWhiter() {
				this.addDialogVisible = true;
			},
			//移除白名单
			removeWhiter(row) {
				this.$confirm('确定要移除白名单吗?', '提 示', {
					type: 'warning',
					distinguishCancelAndClose: true,
					confirmButtonText: '确 定',
					cancelButtonText: '取 消'
				}).then(() => {
					this.frozenLoading = true; //防重复
					this.$api.post('gray_list/removeWhiteUser', {id:row.id}, res => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: res.msg,
								duration: 2000,
							})
							let params = this.searchForm;
							this.getData(params);
							this.frozenLoading = false;
						} else {
							this.$message.error(res.msg);
							this.frozenLoading = false;
						}
					})
				}).catch(() => {

				})
			},
			handleSearch(searchForm) { //搜索
				this.currentPage = 1;
				searchForm.page = 1;
				this.getData(searchForm);
			},
			//分页
			handleCurrentChange(page) { //当前选中页
				this.currentPage = page;
				this.searchForm.page = page;
				this.searchForm.limit = this.pageSize;
				this.getData(this.searchForm);
			},
			handleSizeChange(limit) { //条数
				this.currentPage = 1;
				this.pageSize = limit;
				this.searchForm.page = 1;
				this.searchForm.limit = limit;
				this.getData(this.searchForm);
			},
			getData(params) { //初始化数据
				this.loading = true;
				this.$api.post("gray_list/whiteUserList", params, res => {
					if (res.code == 0) {
						let data = res.data;
						this.total = data.count; //总数
						this.userTable = data.list;
					} else {
						this.$message.error(res.msg);
					}
					//渲染结束后取消加载
					this.loading = false;
				})
			},
		}
	};
</script>

<style scoped>
	.el-input,
	.el-select {
		width: 180px !important;
	}
</style>
